"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Farm = void 0;
/**
 * Farm LP Tokens.
 *
 * @public
 */
class Farm {
    /** @internal */
    constructor(lpTokenBalance, earnedYETI, totalLPStaked, rewardRate) {
        this.lpTokenBalance = lpTokenBalance;
        this.earnedYETI = earnedYETI;
        this.totalLPStaked = totalLPStaked;
        this.rewardRate = rewardRate;
    }
    equals(that) {
        return (this.lpTokenBalance.eq(that.lpTokenBalance) &&
            this.earnedYETI.eq(that.earnedYETI) &&
            this.totalLPStaked.eq(that.totalLPStaked) &&
            this.rewardRate.eq(that.rewardRate));
    }
}
exports.Farm = Farm;
//# sourceMappingURL=Farm.js.map